<script setup>
  import ComponentBadge from "@components/Badges/Badge.vue";
  import {MedButton, MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "MedicationComponentRowControl",
  });

  defineProps({
    dataHashId: {
      type: String,
      required: true,
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["click"]);

  const onClick = () => {
    emit("click");
  };
</script>

<template>
  <div :id="'p4umc-medication-rowcontrol' + dataHashId" class="mr-2" :data-test="getTestId('container')">
    <MedTooltip :content="showBadge ? 'Weitere Angaben sind hinterlegt' : 'Weitere / abweichende Angaben'">
      <template v-if="showBadge">
        <ComponentBadge icon="info" class="text-mcgreen">
          <MedButton
            flat
            aria-label="Hinterlegte Angaben bearbeiten"
            variant="primary"
            icon="edit"
            rounded="full"
            :data-test="getTestId('button-button')"
            @click="onClick"
          />
        </ComponentBadge>
      </template>

      <template v-else>
        <MedButton
          flat
          aria-label="Weitere oder abweichende Angaben bearbeiten"
          variant="primary"
          icon="edit"
          rounded="full"
          :data-test="getTestId('button-button')"
          @click="onClick"
        />
      </template>
    </MedTooltip>
  </div>
</template>
